// import hr from '../assets/curve-hr.svg';

export default function Footer() {
  return (
    <div className="mt-4 bg-dark-200 rounded-md text-white px-8 py-4">
      <p className="text-sm font-light text-center">
        <a href="https://github.com/radendi">Template Referred From radendi.</a>
      </p>
    </div>
  );
}
